import React from "react";
import {  CssBaseline } from "@mui/material";
import AppRouter from "./AppRouter";
import { Toaster } from "react-hot-toast";
import "./App.css";
import 'rsuite/dist/rsuite.min.css';
function App() {

  return (
    <div className="App">
      <Toaster
        position="top-left"
        reverseOrder={true}
      />
      <div>
        <CssBaseline />
        <AppRouter />
      </div>
    </div>
  );
}

export default App;
